import basicRequest from '../js/basicRequest.js';

const baseURL = '/api/aicp-system';
const loadCodeItemUrl = baseURL + '/v1/system/code/getByCode';
const loadCodesItemUrl = baseURL + '/v1/system/code/getByCodes';
const loadConfigValuesUrl = baseURL + 'v1/system/configuration/getValues';

const initWidgets = function(opt) {
    let pageData = opt.pageData || {};
    let rules = opt.rules || [];

    //添加计数器，用于判断
    var me = this;
    let unLoadedCount = rules.length;
    if (unLoadedCount <= 0) {
        _defaultInitComplate(pageData, rules, opt);
        return;
    }
    if (me.unLoadedCount == 0) {
        //如果没有需要初始化的控件，立即回调
        _defaultInitComplate(pageData, rules, opt);
        return;
    }

    for (let i = 0; i < rules.length; i++) {
        _initWidget(pageData, rules[i], opt, function() {
            unLoadedCount--;
            if (unLoadedCount == 0) {
                _defaultInitComplate(pageData, rules, opt);
            }
        });
    }
};

const _defaultInitComplate = function(pageData, rules, opt) {
    if (typeof opt.initComplate == 'function') {
        opt.initComplate(pageData, rules, opt);
    } else {
        // console.log('initWidgets未设置initComplate');
    }
};

const prepareInit = function(option) {
    let prepareInitUrl = option.prepareInitUrl;
    let postData = option.data || {
        includeProperties: ''
    };
    //let appendUniAppToken = option.appendUniAppToken===undefined?true:option.appendUniAppToken;
    //let needLogin = option.needLogin===undefined?true:option.needLogin;
    //这里默认true
    //let forceRegainUniAppToken = option.forceRegainUniAppToken===undefined?true:option.forceRegainUniAppToken;

    if (typeof includeProperties == 'object') {
        includeProperties = JSON.stringify(includeProperties);
        // console.log('传递的includeProperties参数为JSON格式对象,转换为字符串……:' + includeProperties);
    }

    let me = this;
    basicRequest.request({
        context: option.context,
        data: postData,
        isShowLoading: false,
        //needLogin:needLogin,
        //appendUniAppToken:appendUniAppToken,
        //forceRegainUniAppToken:forceRegainUniAppToken,
        url: prepareInitUrl,
        success: function(data, message) {
            if (typeof option.success == 'function') {
                option.success(data);
            }
        },
        error: function(data, message, parameters) {
            console.error('prepareInit-error', message);
            if (typeof option.error == 'function') {
                option.error(data, message);
                return;
            }

            // option.context.$message.error('程序执行异常，请与管理员联络!\n' + message);
        }
    });
};

/**
 * @param {Object} $data
 * @param {Object} rule 规则,详见如下:
 * 		codeItemKey:使用公共的编码表查询
 * 		loadDataUrl【优先】自定义初始化的数据，无需带域名端口，会自动加上(注：不能带参数?)
		params:只能是简单的对象(不支持二级),会自动做会查询的参数,只对loadDataUrl有效
		defaultItems 增加本地数据,请与查询预期返回的数据格式一致
 * 		excludeValues 排除选项不显示
		dataLoadSuccess(pageData,rule,data) 数据加载完成后自定义处理方法,自己决定数据如何处理 data为查询后的数据
			注:dataLoadSuccess设置后excludeValues和defaultItems将无qt
 * @param {Object} initComplate 
 */
const _initWidget = function(pageData, rule, opt, initComplate) {
    let needLogin = rule.needLogin === undefined ? true : rule.needLogin;
    let appendUniAppToken = rule.appendUniAppToken === undefined ? true : rule.appendUniAppToken;

    let postUrl = '';
    if (!rule.codeItemKey && !rule.loadDataUrl) {
        if (typeof initComplate == 'function') {
            console.error(rule.name + '未设置codeItemKey和loadDataUrl,规则异常');
            initComplate();
        }
        return;
    }
    if (rule.loadDataUrl) {
        //自定义加载数据
        postUrl = rule.loadDataUrl;
        if (postUrl.indexOf('?') < 0) {
            postUrl += '?t=1';
        }
        if (rule.params && typeof rule.params == 'object') {
            for (let p in rule.params) {
                postUrl += '&' + p + '=' + rule.params[p];
            }
        }
    } else {
        if (!rule.codeItemKey) {
            console.error(rule.name + '未设置codeItemKey');
        }
        postUrl = loadCodeItemUrl + '?code=' + rule.codeItemKey;
    }
    // console.log(rule.name + '初始化数据,地址:' + postUrl);
    if (rule.defaultItems instanceof Array) {
        pageData[rule.name] = [...rule.defaultItems];
    }

    basicRequest.request({
        context: opt.context,
        url: postUrl,
        isShowLoading: false,
        needLogin: needLogin,
        appendUniAppToken: appendUniAppToken,
        success: function(data, message, parameters) {
            if (typeof rule.dataLoadSuccess == 'function') {
                rule.dataLoadSuccess(pageData, rule, data, opt);
            } else {
                if (rule.loadDataUrl) {
                    //自定义加载器则直接赋值
                    pageData[rule.name] = data.content;
                } else {
                    //公共的编码加载器,则初始化
                    for (let i = 0; i < data.content.length; i++) {
                        if (_isExistExcludeValue(data.content[i].value, rule.excludeValues)) {
                            continue;
                        }
                        pageData[rule.name].push({
                            name: data.content[i].name,
                            value: data.content[i].value
                        });
                    }
                }
            }
            if (typeof initComplate == 'function') {
                initComplate();
            }
        }
    });
};

/**
 * 加载服务器配置的code，多个code用,分隔
 * @param {Object} codes
 */
const loadCodes = function(parameters) {
    // console.log('loadCodes……');
    let multipleCodeStr = parameters.multipleCodeStr; //多个用,号分隔
    let success = parameters.success;
    let error = parameters.error;
    let context = parameters.context;

    //未测试，不推荐使用，自动初始化到pageData则不支持排除和value转整型
    let isInitPageData = parameters.isInitPageData; //是否需要直接帮初始化到pageData中
    let pageData = parameters.pageData; //isInitPageData必须为true，否则无效
    let pageDateKeys = parameters.pageDateKeys || ''; //多个用逗号分隔的字符串

    let url = loadCodesItemUrl;
    basicRequest.request({
        context,
        url: url,
        ajaxOpt: {
            //ajax的参数配置
            type: 'GET' //HTTP请求类型
        },
        data: {
            codes: multipleCodeStr
        },
        success(data, parameters) {
            let codesJson = data.data;

            if (typeof success == 'function') {
                success(codesJson);
            }

            if (isInitPageData === true) {
                let pageDateKeys = pageDateKeys.split(',');
                for (let i = 0; i < pageDateKeys.length; i++) {
                    if (pageDateKeys[i]) {
                        continue;
                    }
                    initPageDataItem(pageData, codesJson, pageDateKeys[i]);
                }
            }
        },
        error(error, message, parameters) {
            console.error('loadCodes-error', message);
            if (typeof error == 'function') {
                error();
            }
            //    else {
            //     context.$message.error("程序执行异常，请与管理员联络!\n" + message);
            //   }
        }
    });
};

/**
 * loadCodes会返回多个编码明细，将指定的codeKey加入到对应pageData属性中
 * 注：配合loadCodes使用
 * @param {Object} target对应pageData的属性,查找到的编码明细加入到此处
 * @param {Object} codesJson loadCodes返回的值,格式参考loadCodes
 * @param {Object} codeKey pageDate的属性名
 * @param {Object} parseValueToInt [默认false]value是否转为int类型
 * @opt {Object} 一些配置参数
 * 	excludeValues：[] 要排除的值，那些值要除排掉（场景：某个配置项不需要显示）
 * 	includeOtherPropertys:[] 是否要包含除label,value以外的其它属性（场景：要包含扩展字段）
 *
 */
const initPageDataItem = function(target, codesJson, codeKey, parseValueToInt, option) {
    if (!codesJson[codeKey]) {
        return;
    }

    let opt = {
        //Axios默认配置
        excludeValues: [] //排除的数据项
    };
    opt = {
        ...opt,
        ...option
    };

    let excludeValues = opt.excludeValues;
    let includeOtherPropertys = opt.includeOtherPropertys || []; //包含的其它属性

    let codeItems = codesJson[codeKey];
    for (let i = 0; i < codeItems.length; i++) {
        let value = codeItems[i].value;
        if (parseValueToInt) {
            value = value - 0;
        }
        if (_isExistExcludeValue(value, excludeValues)) {
            continue;
        }
        let item = {
            id: codeItems[i].id,
            label: codeItems[i].name,
            name: codeItems[i].name,
            value: value,
            extend2: codeItems[i].extend2
        };
        for (let t = 0; t < includeOtherPropertys.length; t++) {
            let _p = includeOtherPropertys[t];
            item[_p] = codeItems[i][_p];
        }
        target.push(item);
    }
    // console.log('initPageDataItem-over:' + JSON.stringify(target));
};

/**
 * loadCodes会返回多个编码明细，查询指定key下面的codeitem对象
 * 注：配合loadCodes使用
 * 	对多个编码数据对象（格式如下）进行遍历，返回item
 * @param {Object} codeKey 编码例如：yes_no
 * @param {Object} value  返回编码明细对象。例如：传入yes_no,1则返回1对应的那个codeitem
 */
const getCodeItemByKeyForCodes = function(codesResult, codeKey, value) {
    //console.log("getCodeItemByKeyForCodes");
    let defaultIteme = {
        fd_name: '',
        fd_value: ''
    };
    if (!value || value == 0) {
        return defaultIteme;
    }
    let foundCodeItems = codesResult[codeKey];
    if (!foundCodeItems || foundCodeItems.length == 0) {
        return defaultIteme;
    }

    let valueType = 's'; //s(单选)/m(多选)
    let values = [value];
    if (typeof value == 'string' && value.indexOf(',') > 0) {
        valueType = 'm';
        values = value.split(',');
    }

    let foundCodes = [];
    for (let i = 0; i < values.length; i++) {
        for (let j = 0; j < foundCodeItems.length; j++) {
            if (foundCodeItems[j].fd_value + '' == values[i] + '') {
                foundCodes.push(foundCodeItems[j]);
                continue;
            }
        }
    }
    if (valueType == 's') {
        return foundCodes[0];
    }
    return foundCodes;
};

const _isExistExcludeValue = function(value, excludeValues) {
    if (excludeValues == undefined) {
        return false;
    }
    for (let i = 0; i < excludeValues.length; i++) {
        if (value == excludeValues[i]) {
            return true;
        }
    }
    return false;
};

/**
 * 加载系统配置项
 * @param {Object} parameters
 */
const loadConfigValues = function(parameters) {
    let context = parameters.context;
    let configNames = parameters.configNames; //多个用,号分隔
    let success = parameters.success;
    let error = parameters.error;

    basicRequest.request({
        context,
        url: loadConfigValuesUrl,
        headers: {
            'content-type': 'application/x-www-form-urlencoded'
        },
        data: {
            names: configNames
        },
        success(data, parameters) {
            let configValuesJson = data.content;
            if (typeof success == 'function') {
                success(configValuesJson);
            }
        },
        error(error, message, parameters) {
            if (typeof error == 'function') {
                error();
            }
            //    else {
            //     context.$message.error("程序执行异常，请与管理员联络!\n" + message);
            //   }
        }
    });
};

const initListRowsCode = function(rows, initCodeRules) {
    for (let p in initCodeRules) {
        for (let i = 0; i < rows.length; i++) {
            let row = rows[i];
            for (let cp in row) {
                if (p == cp) {
                    let cis = _findItemByValue(initCodeRules[p], row[cp]);
                    if (cis.length > 0) {
                        row[p + 'CodeItems'] = cis;
                        row[p + 'Desc'] = _getDescByObjets(cis, 'name');
                    }
                }
            }
        }
    }
};

/**
 * 私有的
 * @param {Object} codeItems
 * @param {Object} value
 */
const _findItemByValue = function(codeItems, value) {
    value = ',' + value + ',';
    let cis = [];
    for (let i = 0; i < codeItems.length; i++) {
        if (value.indexOf(',' + codeItems[i].value + ',') >= 0) {
            cis.push(codeItems[i]);
        }
    }
    return cis;
};

const _getDescByObjets = function(cis, key) {
    let descArr = [];
    for (let i = 0; i < cis.length; i++) {
        descArr.push(cis[i][key]);
    }
    return descArr + '';
};

export default {
    prepareInit,
    initWidgets,

    loadCodes,
    initPageDataItem,
    getCodeItemByKeyForCodes,

    loadConfigValues,

    initListRowsCode
};
